// the languages upskill teaches. modern and classical chinese are two languages, they share characters but not words or grammar. a deck is one set of cards, a language has one or more decks.
// japanese keeps its three decks, every other language is one deck of letters or of everyday words

export interface LanguageInfo {
  id: string;
  name: string;
  native: string;
  // for lang="" on the card so the right font and reader are used
  tag: string;
}

export interface DeckInfo {
  id: string;
  lang: string;
  label: string;
  kind: "letters" | "words";
}

export const LANGUAGES: LanguageInfo[] = [
  { id: "ja", name: "Japanese", native: "日本語", tag: "ja" },
  { id: "ko", name: "Korean", native: "한국어", tag: "ko" },
  { id: "zh", name: "Modern Chinese", native: "中文", tag: "zh" },
  { id: "lzh", name: "Classical Chinese", native: "文言", tag: "lzh" },
  { id: "es", name: "Spanish", native: "Español", tag: "es" },
  { id: "fr", name: "French", native: "Français", tag: "fr" },
  { id: "de", name: "German", native: "Deutsch", tag: "de" },
  { id: "ru", name: "Russian", native: "Русский", tag: "ru" },
  { id: "el", name: "Greek", native: "Ελληνικά", tag: "el" },
  { id: "eo", name: "Esperanto", native: "Esperanto", tag: "eo" }
];

export const DECK_INFO: DeckInfo[] = [
  { id: "hiragana", lang: "ja", label: "hiragana", kind: "letters" },
  { id: "katakana", lang: "ja", label: "katakana", kind: "letters" },
  { id: "kanji", lang: "ja", label: "kanji", kind: "words" },
  { id: "hangul", lang: "ko", label: "hangul letters", kind: "letters" },
  { id: "ko-words", lang: "ko", label: "korean words", kind: "words" },
  { id: "zh-words", lang: "zh", label: "modern chinese words", kind: "words" },
  { id: "lzh-words", lang: "lzh", label: "classical chinese words", kind: "words" },
  { id: "es-words", lang: "es", label: "spanish words", kind: "words" },
  { id: "fr-words", lang: "fr", label: "french words", kind: "words" },
  { id: "de-words", lang: "de", label: "german words", kind: "words" },
  { id: "ru-letters", lang: "ru", label: "cyrillic letters", kind: "letters" },
  { id: "el-letters", lang: "el", label: "greek letters", kind: "letters" },
  { id: "eo-words", lang: "eo", label: "esperanto words", kind: "words" }
];

// the decks someone starts with, so nothing changes for people who only study japanese
export const STARTER_DECKS = ["hiragana", "katakana", "kanji"];

export function deckInfo(id: string): DeckInfo | undefined {
  return DECK_INFO.find((deck) => deck.id === id);
}

export function languageOfDeck(id: string): string {
  return deckInfo(id)?.lang || id.split("-")[0];
}
